import React from "react";
import RouterContainer from "../container";
import LoginPage from "modules/login/LoginPage";
import PublicPage from "router/pages/public";

const PrivateRoutes = ({ children }) => {
    return (
        <RouterContainer
            loggedChildren={children}
            unloggedChildren={<LoginPage />}
        />
    );
};

export default PrivateRoutes;
